import React from "react";
import Form from "./Form";
import { FormattedMessage } from "react-intl";
import { APP_VERSION } from "../../constants";
import AuthLayout from "../../layouts/AuthLayout";

const SetPassword = ({ reset }) => {

  return (

    <AuthLayout
      title={<FormattedMessage id="set_password" defaultMessage="Set Password" />}
      description={<FormattedMessage id="set_password_desc" defaultMessage="Please set your new password by following the instructions below." />}
    >
      <Form reset={reset} />
    </AuthLayout>

  );
};

export default SetPassword;
